import { FAQ_QUERY_KEY } from "@frontend-shared/constants";
import type { IFaqCategory } from "@frontend-shared/types";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { apiClient } from "@/api/services";

interface IUseFaqDataProps {
  // NOTE: NSAI-6608 — the global search palette reads the FAQ only while it is
  // open with a searchable query.
  isEnabled?: boolean;
}

export const useFaqData = ({ isEnabled = true }: IUseFaqDataProps = {}) => {
  const { i18n } = useTranslation();

  return useQuery({
    // NOTE: FAQ content is localized server-side via the request language header, so the active language must be part of the key to refetch on language change
    queryKey: [FAQ_QUERY_KEY, i18n.language],
    queryFn: async (): Promise<IFaqCategory[]> => {
      const response = await apiClient.get<IFaqCategory[]>("/help/faq");
      return response.data;
    },
    staleTime: Infinity,
    enabled: isEnabled,
  });
};
